import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from '../../services/message.service';
import { Plugins, FilesystemDirectory } from '@capacitor/core';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { HttpClient } from '@angular/common/http';
import { HttpEventType } from '@angular/common/http';
import { AlertController, ToastController, ModalController, IonRouterOutlet } from '@ionic/angular';
import { PersonalMessage, PersonalMessageDetail } from '../../models/personal-message';
import { FeedbackPage } from '../feedback/feedback.page';
import * as moment from 'moment';

const { Filesystem, Storage } = Plugins;
const FILE_KEY = 'files';

@Component({
  selector: 'app-personal-message-detail',
  templateUrl: './personal-message-detail.page.html',
  styleUrls: ['./personal-message-detail.page.scss'],
})
export class PersonalMessageDetailPage implements OnInit {

  id: any = null;
  messageDetail:PersonalMessage = null;
  downloadProgress: number;
  downloadUrl: any = '';
  is_feedbackModal = false;
  myFiles = [];
  is_dark_mode = false; 

  constructor(
    private router: Router, 
    private messageService: MessageService,
    private fileOpener: FileOpener,
    private http: HttpClient,
    public alertController: AlertController,
    public toastController: ToastController,
    private route: ActivatedRoute,
    private modalCtrl: ModalController,
    private routerOutlet: IonRouterOutlet
  ) 
  {}

  ionViewWillEnter(){
    let isDark = localStorage.getItem('dark_mode');
    if(isDark == 'true'){
      this.is_dark_mode = true;
    }else{
      this.is_dark_mode = false;
    }
    
  }

  ngOnInit() {
    if (this.route.snapshot.data['detailById']) {
      const response = this.route.snapshot.data['detailById'] as PersonalMessageDetail;
      this.messageDetail = response.data;
      if(response.data.is_feedback == 1 && response.data.feedback_q.length > 0){
        this.is_feedbackModal = true;
      }
      this.downloadUrl = response.data.document_url;
    }
  }

  async loadFiles(){
    const videoList = await Storage.get({key: FILE_KEY });
    this.myFiles = JSON.parse(videoList.value) || [];
  }

  private getMimeType(name:any){
    if(name.indexOf('pdf') >= 0){
      return 'application/pdf';
    }else if(name.indexOf('png') >= 0){
      return 'application/png';
    }else if(name.indexOf('mp4') >= 0){
      return 'application/mp4';
    }else if(name.indexOf('jpeg') >= 0){
      return 'application/jpeg';
    }else if(name.indexOf('JPEG') >= 0){
      return 'application/JPEG';
    }else if(name.indexOf('docx') >= 0){
      return 'application/docx';
    }else if(name.indexOf('doc') >= 0){
      return 'application/doc';
    }
  }

  private convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob)
  });

  downloadFile() {
    this.http.get(this.downloadUrl, {
      responseType : 'blob',
      reportProgress: true,
      observe: 'events'
    }).subscribe(async event => {
      if(event.type === HttpEventType.DownloadProgress){
        this.downloadProgress = Math.round((100 * event.loaded) / event.total);
        
      }else if(event.type === HttpEventType.Response){
        this.downloadProgress = 0;
        
        
        const name = this.downloadUrl.substr(this.downloadUrl.lastIndexOf('/') + 1);
        const nameonly = name.substr(0,name.lastIndexOf('.'));
        const ext = name.substr(name.lastIndexOf('.') +0);
        const uniqueName = Math.floor(Math.random() * 26) + Date.now();
        const base64 =  await this.convertBlobToBase64(event.body) as string;
        const fullName = nameonly+uniqueName+ext;
        console.log(nameonly,uniqueName,ext,fullName);
        const saveFile = await Filesystem.writeFile({
          path:fullName,
          data:base64,
          directory:FilesystemDirectory.Documents
        })

        const path = saveFile.uri;
        const mimeType = this.getMimeType(name);

        this.fileOpener.open(path, mimeType)
        .then(() => this.presentToast('Die Datei wurde erfolgreich heruntergeladen und wird nun geöffnet.'))
        .catch(error => this.presentToast('Die Datei wurde heruntergeladen, konnte jedoch nicht geöffnet werden. Bitte schauen Sie in Ihrem Download Ordner nach.'));
      }
    })
    
  }

  async deleteMessage(id:number) {
    const alert = await this.alertController.create({
      cssClass: 'new-message',
      message: '<p>Die Nachricht wird aus Ihrem Konto gelöscht!</p>',
      buttons: [
        {
          text: 'ABBRECHEN',
          role: 'cancel'
        }, {
          text: 'OK',
          handler: () => {
            this.deleteMessageRequest(id);
          }
        }
      ]
    });
    await alert.present();
  }

  deleteMessageRequest(id){
    const data = {id:id}
    this.messageService.deleteMessage(data).subscribe( 
      response => {     
        this.presentToast(response.message); 
        this.router.navigate(['personal-messages']);
    },
    error => {
      this.presentToast(error.error.message);       
    })
  }

  async replyMeg() {
    const alert = await this.alertController.create({
      cssClass: 'new-message',
      header: 'Ihre Antwort',
      message: '<p>Bitte geben Sie Ihre Antwort auf unsere Nachricht "'+this.messageDetail.title+'" in das Textfeld ein</p>',
      inputs: [        
        {
          name: 'new_message',
          id: 'new_message',
          type: 'textarea',
          placeholder: 'Ihre Nachricht an uns'
        }
      ],
      buttons: [
        {
          text: 'ABBRECHEN',
          role: 'cancel'
        }, {
          text: 'Absenden',
          handler: (alertData) => {
            this.sendNewMessage(alertData.new_message);
          }
        }
      ]
    });
    await alert.present();
  }

  sendNewMessage(message){
    const data = {message:message, type:'Reply-Message', message_id:this.id}
    this.messageService.replyMessage(data).subscribe( 
      response => {     
        this.presentToast(response.message); 
    },
    error => {
      this.presentToast(error.error.message);       
    })
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

  backPage(){
    this.router.navigate(['personal-messages']);
  }

  backHome(){
    this.router.navigate(['home']);
  }

  
  async openFeedback() {
    const modal = await this.modalCtrl.create({
      component: FeedbackPage,
      backdropDismiss: true,
      swipeToClose: true,
      presentingElement: this.routerOutlet.nativeEl,
      componentProps: {
        id: this.messageDetail.id,
        feedbackQuestion: this.messageDetail.feedback_q,
      }
    });
    modal.present();
  }

}
